export default __webpack_public_path__ + "static/media/loginScreenImage.da58ca5a.svg";